module.exports = __webpack_public_path__ + "static/media/hbb_grid_3.a3af5f94.png";